export default "__VITE_ASSET__BW0CD4L9__"